"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.RecoveryOrigin=void 0;var t;(function(e){e.BasketEntryPoint="Basket Entry Point",e.ProductDetailsView="Product Details View",e.StoreView="Store View"})(t||(exports.RecoveryOrigin=t={}));
//# sourceMappingURL=RecoveryOrigin.js.map
